import React from "react";

import { Grid } from "@material-ui/core";
import LoadingButton from '@mui/lab/LoadingButton';
import DownloadIcon from '@mui/icons-material/Download';
import LinearProgress from '@mui/material/LinearProgress';

import Scheduler, { AppointmentDragging } from "devextreme-react/scheduler";
import Draggable from "devextreme-react/draggable";
import { locale, loadMessages } from "devextreme/localization";

import { Document, Packer, Paragraph } from "docx";
import { saveAs } from "file-saver";

import service from '../../../../plas/map/places/pharmacies/service';
import alerter from "../../../alerts/alerter"
import CircularProgress from "@mui/material/CircularProgress";
import * as Constants from "../../../../consts/Constants";

export default function Duties() {

  const draggingGroupName = "appointmentsGroup";
  
  const [date, setDate] = React.useState(new Date())
  const [range, setRange] = React.useState(null)
  const [pharmacies, setPharmacies] = React.useState([]);
  const [duties, setDuties] = React.useState([]);
  const [loadingPharmacies, setLoadingPharmacies] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [downloading, setDownloading] = React.useState(false)

  React.useEffect(() => {
    loadMessages({
      en: { "dxScheduler-switcherMonth": "Mes" },
    });
    locale("es");
    getPharmacies();
  }, []);

  
  const getDuties = (range) => {
    let startTime = range[0];
    let endTime = range[1];
    setDuties([]);
    setLoading(true);

    service.api.duties.search(startTime, endTime, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setDuties(response.result)
      }
      setRange(range);
      setLoading(false);
    });
  }

  const getPharmacies = () => {

    setLoadingPharmacies(true)
    service.api.pharmacies.get((response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setPharmacies(response.result)
        setLoadingPharmacies(false)
      }
    });
  }

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        marginTop: 6,
        marginBottom: 16,
        height: 2
      }} />
  );

  const preventEvent = (e) => {
    e.cancel = true;
  }

  const onAppointmentRemove = (e) => {
    let dutyId = e.appointmentData.id;

    service.api.duties.delete(dutyId, (response) => {
      if (response.error != null) {
        alerter.showError(response.error)
        setDuties([...duties])
      } else {
        setDuties(duties.filter((item) => item.id !== dutyId))
      }
    })

    e.cancel = true
  }

  const onAppointmentAdd = (e) => {
    let pharmacy = e.fromData;
    let date = e.itemData.startDate;

    if (pharmacy) {

      const duty = {
        placeId: pharmacy.id,
        date: new Date(date).getTime(),
      };

      service.api.duties.create(duty, (response) => {
        if (response.error != null) {
          alerter.showError(response.error);   
        } else {
          let newDuty = response.result
          newDuty.place = pharmacy;
          setDuties([...duties, response.result]);
        }
      });

    }
  }

  const onAppointmentUpdating = (e) => {
    let pharmacy = e.oldData.place

    const duty = {
      id: e.oldData.id,
      placeId: pharmacy.id,
      date: new Date(e.newData.startDate).getTime(),
    }

    service.api.duties.update(duty, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        let updatedDuty = response.result;
        updatedDuty.place = pharmacy;
        setDuties([...duties.filter((item) => item.id !== response.result.id), updatedDuty]);
      }
    })

    e.cancel = true
  }

  const onListDragStart = (e) => {
    e.cancel = true;
  }

  const onItemDragStart = (e) => {
    e.itemData = e.fromData;
  }

  const onItemDragEnd = (e) => {
    if (e.toData) {
      e.cancel = true;
    }
  }

  const generateWordDocument = (duties) => {
    let duty;
    let i;
    const childrens = [];

    const monthOptions = {month: 'long', year: 'numeric'};

    let monthText = "TURNOS MES DE " + date.toLocaleDateString('es-ES', monthOptions).toUpperCase();

    const monthParagraph = new Paragraph({text: monthText, style: "myCustomStyle"});
    childrens.push(monthParagraph);
    childrens.push(new Paragraph({text:""}));
    childrens.push(new Paragraph({text:""}));
    childrens.push(new Paragraph({text:""}));

    let montDuties = [];
    for (i = 0; i < duties.length; i++) {
      duty = duties[i];
      let dutyDate = new Date(duty.date);
      if (dutyDate.getMonth() === date.getMonth()) {
        montDuties.push(duty);
      }
    }

    montDuties = montDuties.sort((a, b) => a.date - b.date);

    const dayOptions = {weekday: 'long'};

    for (i = 0; i < montDuties.length; i++) {
      duty = montDuties[i]
      let dutyDate = new Date(duty.date);
      const dayText = dutyDate.toLocaleDateString('es-ES', dayOptions).toUpperCase() + " " + dutyDate.getDate();
      let whiteSpace = "\t";
      if (dayText.length < 12)
        whiteSpace += "\t"
      let pharmacyName = duty.place.name.toUpperCase();
      if (pharmacyName.toUpperCase().startsWith("FARMACIA"))
        pharmacyName = pharmacyName.substring(9)
      const paragraph = new Paragraph({
        text: dayText + ":" + whiteSpace + pharmacyName.toUpperCase(),
        style: "myCustomStyle"
      });
      childrens.push(paragraph);
    }

    const doc = new Document({ 
      styles: {
        paragraphStyles: [
          {
            id: "myCustomStyle",
            name: "My Custom Style",
            basedOn: "Normal",
            run: {
              color: "000000",
              size: 20,
              font: "Consolas"
            },
            paragraph: {
              spacing: { line: 240, before: 30, after:30 }
            }
          }
        ]
      },
      sections: [{ children: childrens }] });   
    
    saveDocumentToFile(doc, monthText+".docx");
  }

  const saveDocumentToFile = (doc, fileName) => {
    const mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    // Create a Blob containing the Document instance and the mimeType
    Packer.toBlob(doc).then((blob) => {
      const docblob = blob.slice(0, blob.size, mimeType);
      // Save the file using saveAs from the file-saver package
      saveAs(docblob, fileName);
      setDownloading(false);
    });


  }

  const generateWord = () => {
    setDownloading(true);
    generateWordDocument(duties);
  }

  return (
    <Grid container spacing={2} >
      <Grid item xs={12} style={{ textAlign: "center"}}>
        { loadingPharmacies ? (
            <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
        ):(
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={true} style={{textAlign: 'left'}}>
            <span style={{ fontSize: '28px' }}>
              Farmacias de turno
            </span>
                    <span style={{ fontSize: '20px', marginLeft: '16px', textAlign: 'left', color: 'gray'}}>
              <i>{date.toLocaleString('default', { month: 'long', year: 'numeric' })}</i>
            </span>
                  </Grid>
                  <Grid item>
                    <LoadingButton
                        loadingPosition="start"
                        startIcon={<DownloadIcon />}
                        loading={downloading}
                        variant="contained"
                        onClick={generateWord}>
                      <b>Descargar</b>
                    </LoadingButton>
                  </Grid>
                </Grid>
                <ColoredLine color="gray"/>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2} >
                  <Grid item xs={12} md={'auto'}>
                    <Draggable
                        group={draggingGroupName}
                        onDragStart={onListDragStart}>
                      { pharmacies.map((item) => {
                        return (
                            <Draggable
                                style={{ padding: '8px', paddingLeft: '16px', paddingRight: '16px', margin: '8px'}}
                                key={item.id}
                                className="item dx-card dx-theme-text-color dx-theme-background-color"
                                clone={true}
                                data={item}
                                group={draggingGroupName}
                                onDragStart={onItemDragStart}
                                onDragEnd={onItemDragEnd}>
                              {item.name}
                            </Draggable>
                        )
                      })
                      }
                    </Draggable>
                  </Grid>
                  <Grid item xs={true}>
                    <Scheduler
                        disabled={loading}
                        style={{height: '100%'}}
                        dataSource={duties.map((item) => { return { id: item.id, startDate: item.date, allDay: true, text: item.place.name }})}
                        defaultCurrentView="month"
                        views={[{ type: "month", intervalCount: 1 }]}
                        editing={{
                          allowAdding: false,
                          allowDeleting: !loading,
                          allowDragging: !loading,
                          allowResizing: false,
                          allowTimeZoneEditing: false,
                          allowUpdating: !loading,
                        }}
                        defaultCurrentDate={new Date()}
                        onAppointmentRemove={onAppointmentRemove}
                        onAppointmentDblClick={preventEvent}
                        onAppointmentDeleted={onAppointmentRemove}
                        onAppointmentUpdating={onAppointmentUpdating}
                        onAppointmentFormOpening={preventEvent}
                        onContentReady={(e)=> {
                          let newRange = [e.component.getStartViewDate().getTime(), e.component.getEndViewDate().getTime()]
                          if (!loading && (!range || newRange[0] !== range[0])) {
                            getDuties(newRange);
                          }
                        }}
                        onOptionChanged={ (e)=> {
                          if (e.name === "currentDate") {
                            setDate(e.value)
                          }
                        }
                        }>
                      <AppointmentDragging
                          onRemove={onAppointmentRemove}
                          group={draggingGroupName}
                          onAdd={onAppointmentAdd}/>
                    </Scheduler>
                    { loading ? (<LinearProgress />) : (null) }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
        )}
      </Grid>
    </Grid>
  )
  

}
